function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-3.375 -4.499)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.4,11.25H6.581a3.208,3.208,0,0,0-3.206,3.206v8.976a3.208,3.208,0,0,0,3.206,3.206H22.4A3.208,3.208,0,0,0,25.6,23.432V14.456A3.208,3.208,0,0,0,22.4,11.25Z",
  transform: "translate(0 -1.621)",
  fill: "#0078d7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.4,4.553,6.851,7.006C5.889,7.219,4.5,8.186,4.5,9.362A3.366,3.366,0,0,1,7.118,8.347H22.452v-1.1a3.068,3.068,0,0,0-.743-2.009h0A2.527,2.527,0,0,0,19.4,4.553Z",
  transform: "translate(-0.27)",
  fill: "#0078d7"
}));

function SvgWalletIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.227,
    height: 20.517,
    viewBox: "0 0 22.227 20.517",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon);
export default __webpack_public_path__ + "static/media/wallet-icon.03f6760a.svg";
export { ForwardRef as ReactComponent };